<template>
  <card>
    <slot slot="header">
      <v-toolbar-title>
        <v-icon class="mr-1">vpn_key</v-icon>Redefinir senha
      </v-toolbar-title>
    </slot>

    <slot slot="body">
      <v-form ref="form" lazy-validation>
        <v-container grid-list-lg fluid>
          <v-layout row justify-center align-center wrap>
            <v-flex xs12 sm6>
              <v-text-field
                :type="showPassword ? 'text' : 'password'"
                prepend-icon="lock"
                name="password"
                id="password"
                :label="translate('table.users.field.password')"
                :rules="rules.password"
                v-model="user.password"
              />
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                :type="showPassword ? 'text' : 'password'"
                prepend-icon="check"
                name="confirmation"
                id="confirmation"
                :label="translate('table.users.field.confirmation')"
                :rules="rules.confirmation"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                @click:append="showPassword = !showPassword"
                v-model="user.confirmation"
                @keyup.native.enter="reset()"
              />
            </v-flex>
            <v-flex xs12 class="text-xs-center">
              <v-btn dark class="gradient mx-auto" @click="reset">Redefinir</v-btn>
              <v-btn flat href="#/">Voltar</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </slot>
  </card>
</template>

<style scoped>
.gradient {
  background: linear-gradient(40deg, #4a97ce, #5fbf8d);
}
</style>

<script>
/* eslint-disable handle-callback-err */
import Card from '../shared/Card'
import rules from '../../mixin/rules'

export default {
  components: { Card },
  mixins: [rules],
  data () {
    return {
      showPassword: false,
      rules: {
        // nameRules: [
        //   v => !!v || 'Name is required',
        //   v => (v && v.length >= 10) || 'Name must be less than 10 characters'
        // ]
        password: [
          v => !!v || 'O campo "Senha" é obrigatório',
          v => (v && v.length >= 6) || 'O campo "Senha" precisa ter pelo menos 6 caracteres'
        ],
        confirmation: [
          v => !!v || 'O campo "Confirmacao" é obrigatório',
          v => (v && v.length >= 6) || 'O campo "Confirmacao" precisa ter pelo menos 6 caracteres',
          v => (!!v && v) === this.user.password || 'Os valores informados não conferem'
        ]
      },
      user: {
        password: '',
        confirmation: '',
        token: ''
      }
    }
  },
  mounted () {
    this.user.token = decodeURI(this.$route.query.token)
  },
  computed: {
    // rules: () => ({
    //   password: [
    //     v => !!v || 'O campo "Senha" é obrigatório',
    //     v => (v && v.length <= 6) || 'O campo "Senha" precisa ter pelo menos 6 caracteres'
    //   ],
    //   confirmation: [
    //     v => !!v || 'O campo "Confirmacao" é obrigatório',
    //     v => (v && v.length <= 6) || 'O campo "Senha" precisa ter pelo menos 6 caracteres',
    //     v => v !== this.password || 'Os valores informados não conferem'

    //   ]
    // }
    // )
    // passwordConfirmRules () {
    //   return [
    //     v => !!v || 'O campo "Confirmação" é obrigatório',
    //     v => v !== this.user.password || 'Os valores informados não conferem'
    //   ]
    // }
  },
  methods: {
    reset () {
      if (!this.$refs.form.validate()) {
        this.$store.commit('snackbar/change_values', {
          text: 'Por favor, corrija as validações antes de salvar!',
          color: 'warning',
          dialog: true
        })
        return
      }

      this.$store.commit('loader/change_dialog', true)
      this.$http
        .post('auth/reset-password', this.user)
        .then(res => {
          const {color, text, email} = res.body
          const {password} = this.user

          this.$auth.login({
            body: {email, password},
            redirect: '/home'
          }).then((re) => {
            // this.enableSubscription()
            // this.$router.push('home')
            this.$store.commit('snackbar/change_values', {
              text,
              color,
              dialog: true
            })
            this.$store.commit('loader/change_dialog', false)
          }, err => {
            this.$store.commit('snackbar/change_values', {
              text,
              color,
              dialog: true
            })
          })
        }, er => {
          const {color, text} = er.body

          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text,
            color,
            dialog: true
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/Reset.vue